/**
 * Removes the legacy package type prefix (`M:`, `U:` or `C:`) if one is present. The API uses bare
 * GUIDs, but pay-rules route params from old bookmarks and stored `RemovePackage` action references
 * can still carry the prefixed form, so normalise those before comparing against a live package id.
 * Only the single leading prefix is removed; a bare value is returned untouched.
 * @param id a package id from a route param or a stored action reference
 * @returns the bare package id
 */
export function stripLegacyPackageRefPrefix(id: string): string {
  return id.replace(/^[MUC]:/, '')
}
